import { FARM_CONTEXT_STORAGE_KEY } from '../constants/farmContext';

const subscribedSockets = new WeakSet();

function socketDebugEnabled() {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('waterSocketDebug') === '1';
  } catch {
    return false;
  }
}

function farmSocketDebug(...args) {
  if (!socketDebugEnabled()) return;
  try {
    console.debug('[farm:socket]', ...args);
  } catch {
    /* debug only */
  }
}

/**
 * Emit farm room join with JWT + optional X-Farm-Context mirror (see server registerFarmSocketRooms).
 */
export function emitJoinFarmRooms(socket) {
  if (!socket || typeof socket.emit !== 'function') return;
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    if (!token) {
      farmSocketDebug('join_farm_rooms skipped: missing token', {
        socketId: socket.id || null,
        connected: socket.connected === true,
      });
      return;
    }
    let farmContextId = null;
    try {
      farmContextId = localStorage.getItem(FARM_CONTEXT_STORAGE_KEY);
    } catch {
      farmContextId = null;
    }
    const payload = {
      token,
      ...(farmContextId ? { farmContextId } : {}),
    };
    socket.emit('join_farm_rooms', payload, (ack) => {
      farmSocketDebug('join_farm_rooms ack', {
        ack: ack || null,
        socketId: socket.id || null,
        connected: socket.connected === true,
        farmContextId: farmContextId || null,
      });
      if (ack?.ok === false && farmContextId) {
        socket.emit('join_farm_rooms', { token }, (retryAck) => {
          farmSocketDebug('join_farm_rooms retry without farmContext ack', {
            ack: retryAck || null,
            socketId: socket.id || null,
            connected: socket.connected === true,
          });
        });
      }
    });
  } catch {
    farmSocketDebug('join_farm_rooms failed');
  }
}

/** One connect + immediate join subscription per socket instance. */
export function subscribeSocketFarmRooms(socket) {
  if (!socket || subscribedSockets.has(socket)) return;
  subscribedSockets.add(socket);
  const join = () => emitJoinFarmRooms(socket);
  socket.on('connect', () => {
    farmSocketDebug('connect', { socketId: socket.id || null });
    join();
  });
  socket.on('connect_error', (error) => {
    farmSocketDebug('connect_error', {
      message: error?.message || String(error || ''),
      socketId: socket.id || null,
    });
  });
  if (socket.connected) join();
}
